<template>
  <div id="top-header">
    <el-button type="text" size="large" class="left-title">
      {{ dateTime.dateYear }} {{ dateTime.dateWeek }} {{ dateTime.dateDay }}
      {{ dataWeather.city }}
      {{ dataWeather.weathertemp }}
      <img :src="dataWeather.icontemp" alt="" />
      {{ dataWeather.peraturetemp }}
    </el-button>
    <div class="center-title">
      {{ title }}
    </div>
    <el-dropdown trigger="click" class="go-system">
      <el-button type="text" size="large">
        <span class="go-system-btn">看板切换</span>
        <i class="el-icon-thumb go-system-btn"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <el-link href="#/">品智企业驾驶舱</el-link></el-dropdown-item
        >
        <el-dropdown-item>
          <el-link href="#/spDigitalSigns"
            >销售平台数字管理看板</el-link
          ></el-dropdown-item
        >
        <el-dropdown-item>
          <el-link href="#/purchaseDigitalSigns"
            >采购数字管理看板</el-link
          ></el-dropdown-item
        >
        <el-dropdown-item>
          <el-link href="#/productionDigitalSigns"
            >生产数字管理看板</el-link
          ></el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { weatherOption } from "../../config/weatherOption";

export default {
  name: "topHeader",
  props: {
    title: {
      type: String,
      default: "数据展示",
    },
  },
  data() {
    return {
      dateTime: {
        dateDay: null,
        dateYear: null,
        dateWeek: null,
        weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      },
      dataWeather: {
        city: "北京市",
        dayweather: "晴",
        nightweather: "多云",
        weathertemp: "晴", // 根据时间判断选白天还是晚上的天气
        nighttemp: "3℃",
        daytemp: "15℃",
        peraturetemp: "3℃~15℃", // 根据时间判断选白天还是晚上的温度
        icontemp: "https://cdn.heweather.com/cond_icon/100.png",
      },
    };
  },
  mounted() {
    this.getDateTime();
    this.requestGetWeather();
  },
  methods: {
    // 获取时间
    getDateTime() {
      setInterval(() => {
        this.dateTime.dateYear = this._parseTime(new Date(), "{y}-{m}-{d}");
        this.dateTime.dateWeek = this.dateTime.weekday[new Date().getDay()];
        this.dateTime.dateDay = this._parseTime(new Date(), "{h}:{i}:{s}");
      }, 1000);
    },
    // 获取天气
    requestGetWeather() {
      $.get({
        //这里的url不能写到data对象的外面
        url: "https://api.asilu.com/weather_v2/",
        dataType: "jsonp", // 请求方式为jsonp
        success: (data) => {
          if (data.status === "1") {
            let currTime = new Date().getHours();
            let dailyForecast = data.forecasts[0].casts[0];
            let city = data.forecasts[0].city;
            let daytemp = dailyForecast.daytemp + "℃";
            let nighttemp = dailyForecast.nighttemp + "℃";
            let weathertemp = "";
            let peraturetemp = "";
            if (currTime >= 6 && currTime < 18) {
              weathertemp = dailyForecast.dayweather;
              peraturetemp =
                dailyForecast.nighttemp + "℃~" + dailyForecast.daytemp + "℃";
            } else {
              weathertemp = dailyForecast.nightweather;
              peraturetemp =
                dailyForecast.daytemp + "℃~" + dailyForecast.nighttemp + "℃";
            }
            let icontemp =
              "https://cdn.heweather.com/cond_icon/" +
              weatherOption.weatherCode[weathertemp] +
              ".png";
            this.dataWeather = {
              city,
              daytemp,
              nighttemp,
              weathertemp,
              peraturetemp,
              icontemp,
            };
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#top-header {
  position: relative;
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  background-image: url("../../assets/images/largescreen/head.gif");
  background-repeat: no-repeat;
  background-size: 100% 90%;
  background-position: center;
  background-color: #111111;

  .left-title {
    position: absolute;
    font-weight: bold;
    left: 12px;

    img {
      width: 15px;
      height: 15px;
      filter: brightness(3);
      vertical-align: bottom;
    }
  }

  .center-title {
    position: absolute;
    font-size: 32px;
    font-weight: bold;
    left: 50%;
    top: 25px;
    transform: translateX(-50%);
    color: #fff;
    letter-spacing: 10px;
  }

  .go-system {
    position: absolute;
    font-weight: bold;
    top:3px;
    right: 60px;
    color: #409eff;
    // -webkit-background-clip: text;
    animation: blink 2s linear infinite;
    -webkit-animation: blink 2s linear infinite;
    -moz-animation: blink 2s linear infinite;
    -ms-animation: blink 2s linear infinite;
    -o-animation: blink 2s linear infinite;

    i {
      transform: rotate(90deg);
    }
    .go-system-btn {
      font-weight: bold;
      font-size: 18px;
    }
  }
}
</style>
<style>
@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}

@-webkit-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}

@-moz-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}

@-ms-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}

@-o-keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}
</style>
